import Swiper, { Navigation, Pagination, SwiperOptions } from 'swiper';

class CardCarousel {
    $el: HTMLElement;
    cards: NodeListOf<HTMLElement> | null | undefined;
    swiper: Swiper | null = null;
    config: SwiperOptions;

    constructor($el: HTMLElement, $config: SwiperOptions = {}) {
        this.$el = $el;
        this.cards = $el?.querySelectorAll('.swiper-slide');
        this.config = $config;

        this.createSwiper();
    }

    createSwiper(): void {
        let defaultConfig = {
            modules : [Navigation, Pagination],
            slidesPerView: 1.15,
            spaceBetween: 20,
            loop: false,
            allowTouchMove: true,
            grabCursor: true,
            navigation: {
                nextEl: this.$el.querySelector('.swiper-button-next'),
                prevEl: this.$el.querySelector('.swiper-button-prev')
            },
            pagination: {
                el: this.$el.querySelector('.swiper-pagination'),
                clickable: true,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                },
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 30,
                }
            }
        } as SwiperOptions;

        if (this.cards) {
            this.swiper = new Swiper(this.$el, {
                ...defaultConfig,
                ...this.config
            });
        }
    }
}

export default function initCardCarousel(): void {
    document.addEventListener('DOMContentLoaded', () => {
        const $cardCarouselContainer = document.querySelectorAll<HTMLElement>('.card-carousel');
        const $cardCarouselContainerImpact = document.querySelectorAll<HTMLElement>('.card-carousel-impact');
        const $cardCarouselContainerTheme = document.querySelectorAll<HTMLElement>('.card-carousel-theme');

        $cardCarouselContainer.forEach($container => {
            new CardCarousel($container);
        });

        $cardCarouselContainerImpact.forEach($container => {
            new CardCarousel($container, {
                slidesPerView: 2,
                spaceBetween: 10,
                breakpoints: {
                    576: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 'auto',
                        spaceBetween: 30,
                    },
                }
            });
        });

        $cardCarouselContainerTheme.forEach($container => {
            new CardCarousel($container, {
                breakpoints: {
                    576: {
                        slidesPerView: 1.5,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 32,
                    },
                }
            });
        });
    });
}
